import { supabase } from '@/lib/supabase';

export default function PendingApprovalPage() {
  const handleSignOut = async () => {
    await supabase.auth.signOut();
  };

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-gradient-to-br from-background to-muted">
      <div className="w-full max-w-md p-8 bg-card rounded-lg shadow-lg border">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-yellow-500/10 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold mb-2">Account Pending Approval</h1>
          <p className="text-muted-foreground mb-6">
            Your account has been created successfully, but it needs to be approved by an administrator before you can access the IDE.
          </p>
          <p className="text-sm text-muted-foreground mb-6">
            You'll receive an email notification once your account is approved.
          </p>
          <button
            onClick={handleSignOut}
            className="w-full py-2 px-4 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
